import React, { useEffect, useState } from 'react';
import './LoaderBar.scss';

export const LoaderBar = ({ onFinish }) => {
    const [width, setWidth] = useState(0);
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        let animationFrameId;
        let startTime;

        const duration = 350; // тривалість завантаження в мілісекундах

        const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const percentage = progress * 100;
            setWidth(percentage);

            if (progress < 1) {
                animationFrameId = requestAnimationFrame(animate);
            } else {
                // Плавне зникнення лоадера
                setTimeout(() => {
                    setOpacity(0);
                    // Після завершення анімації повідомляємо батьківський компонент
                    if (onFinish) onFinish();
                }, 200); // Затримка перед зникненням (можна налаштувати)
            }
        };

        animationFrameId = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrameId);
    }, [onFinish]);

    return (
        <div
            className="loader-container"
            style={{ opacity: opacity, transition: 'opacity 0.2s ease' }}
        >
            <div className="loader-text">Loading...</div>
            <div className="progress-bar-container">
                <div
                    className="progress-bar"
                    style={{ width: `${width}%` }}
                ></div>
            </div>
            <div className="loader-subtext">This may takes few seconds</div>
        </div>
    );
};

export default LoaderBar;
